export const SHOW_DIALOGUE_WITH_PROPS = 'SHOW_DIALOGUE_WITH_PROPS';
export const HIDE_DIALOGUE_BOX = 'HIDE_DIALOGUE_BOX';